export const integrationIcons = [
  {
    src: '/assets/images/integrations/GitHub.png',
    width: 227,
    height: 227,
    alt: 'icon',
    style: 'rounded-5xl lg:top-[10%] top-[15%] lg:left-[25%] md:left-[5%] md:top-[20%] -left-[10%]  icon-github',
  },
  {
    src: '/assets/images/integrations/CircleCI.png',
    width: 136,
    height: 137,
    alt: 'icon',
    style: 'rounded-5xl lg:top-[50%] lg:right-[10%] right-[0%] top-[75%] md:right-[10%] md:top-[75%] icon-circleci',
  },
  {
    src: '/assets/images/integrations/JetBrainsTeamCity.png',
    width: 161,
    height: 140,
    alt: 'icon',
    style:
      'rounded-5xl [&>img]:mt-5 lg:top-[10%] lg:right-[35%] icon-jetbrains top-[12%] -right-[10%] md:right-[0%] md:top-[25%]',
  },
  {
    src: '/assets/images/integrations/Jenkins.png',
    width: 160,
    height: 160,
    alt: 'icon',
    style: 'rounded-5xl lg:top-[30%] lg:right-[10%] right-[20%] md:right-[30%] md:top-[35%] top-[30%] icon-jenkins',
  },
  {
    src: '/assets/images/integrations/TravisCI.png',
    width: 115,
    height: 116,
    alt: 'icon',
    style: 'rounded-3xl bottom-[0%] lg:left-[20%] md:left-[0%] left-[30%] icon-travisci',
  },
  {
    src: '/assets/images/integrations/GitLab.png',
    width: 67,
    height: 68,
    alt: 'icon',
    style: 'rounded-3xl bottom-[0%] left-[5%] icon-gitlab',
  },
];

export const flexibleIcon = [
  {
    src: '/assets/images/integrations/screen-2/alibaba.svg',
    width: 64,
    height: 64,
    alt: 'alibaba',
    style: 'rounded-3xl top-[20%] lg:left-[25%] left-[20%] icon-alibaba md:left-[20%] p-10',
  },
  {
    src: '/assets/images/integrations/screen-2/anchor.svg',
    width: 144,
    height: 143,
    alt: 'kubernetes',
    style: 'rounded-5xl top-[20%] lg:right-[40%] -right-[10%] md:right-[25%] icon-anchor',
  },
  {
    src: '/assets/images/integrations/screen-2/autodesk.svg',
    width: 118,
    height: 118,
    alt: 'autodesk',
    style:
      'rounded-5xl lg:bottom-[10%] lg:right-[10%] -bottom-[20%] right-[20%] md:-bottom-[20%] md:right-[30%] icon-autodesk',
  },
  {
    src: '/assets/images/integrations/screen-2/aws.svg',
    width: 140,
    height: 140,
    alt: 'aws',
    style: 'rounded-5xl md:top-[60%] lg:right-[20%] right-[25%] top-[40%] md:right-[5%] icon-aws',
  },
  {
    src: '/assets/images/integrations/screen-2/docker.svg',
    width: 137,
    height: 133,
    alt: 'docker',
    style:
      'rounded-5xl lg:bottom-[20%] lg:left-[10%] -bottom-[10%] left-[70%] md:left-[70%] md:-bottom-[10%]  icon-docker',
  },
  {
    src: '/assets/images/integrations/screen-2/gcm.svg',
    width: 87,
    height: 87,
    alt: 'gcm',
    style: 'rounded-3xl md:top-[45%] lg:left-[20%] top-[30%] left-0 md:left-0  icon-gcm',
  },
  {
    src: '/assets/images/integrations/screen-2/google_cloud.svg',
    width: 87,
    height: 87,
    alt: 'google cloud',
    style: 'rounded-3xl top-[150%] left-[20%]  icon-google_cloud',
  },
  {
    src: '/assets/images/integrations/screen-2/openshift.svg',
    width: 44,
    height: 45,
    alt: 'icon',
    style: 'rounded-3xl -bottom-[10%] lg:right-[30%] right-[50%] md:right-[60%] icon-openshift',
  },
  {
    src: '/assets/images/integrations/screen-2/rancher.svg',
    width: 212,
    height: 212,
    alt: 'icon',
    style:
      'rounded-5xl lg:-bottom-[20%] lg:left-[15%] -left-[10%] md:left-[0%] md:-bottom-[10%] -bottom-[10%] icon-rancher',
  },
  {
    src: '/assets/images/integrations/screen-2/stack.svg',
    width: 116,
    height: 116,
    alt: 'icon',
    style: 'rounded-3xl top-[200%] right-[40%]  icon-stack',
  },
];
